fx.ns("desktop.print", class PrintBoard extends desktop.common.board.Board
{
    constructor(model, componentFactory, options)
    {
        super(model, componentFactory, options);
    }

    /**************************** Getters / Setters **********************/

    get print()
    {
        return this.data;
    }

    set print(val)
    {
        this.data = val;
    }
    
    get currentView()
    {
        if (!this._currentView)
            this._currentView = new desktop.print.PrintView(this);
        
        return this._currentView;
    }

    get areas()
    {
        return this._editableAreas;
    }


    get allChilds()
    {
        if (!this.initialized || !this.pages)
            return [];

        if (!this._allChilds)
        {
            this._allChilds = [];

            this.pages.sort(function(a, b) {  
                return (a.data.number - b.data.number);
            });

            if(this.print.prints.length > 0)
            {
                this._allChilds.push(this._topInfoText);
                this._topInfoText.show();
            }
            else
                this._topInfoText.hide();

            this._allChilds.push.apply(this._allChilds, this.pages);
            
            if(this.print.prints.length <= 0)
            {
                this._allChilds.push( this._addPhotoCard);
                this._addPhotoCard.css("display", "block");
                this._addPhotoCard.show();
                this._addPhotoButton.css("display", "none");
                this._addPhotoButton.hide();
            }
            else
            {
                this._allChilds.push( this._addPhotoButton);
                this._addPhotoButton.css("display", "block");
                this._addPhotoButton.show();
                this._addPhotoCard.css("display", "none");
                this._addPhotoCard.hide();
            }
        }

        return this._allChilds;
    }


    /*************************** Overrides  *************************/

    
    

    __onPhotoExtractedFinished(e){
        let page = this.data.book.addElement(false, "right", true, true);
        page.photosComponents.getItemAt(0).content = e.detail.id;
    }


    onChildUpdated(action)
    {
        if ((action.model instanceof models.ProductPrintPage || action.model instanceof models.CreationElement ) && (action.type == "create" || action.type == "delete"))
            this.delay(this._updateCreationLabel, 250);
        else if ((action.model instanceof models.ProductPrintPage || action.model instanceof models.CreationElement ) && action.impacts("quantity"))
            this.delay(this._updateCreationLabel, 250);
   }

    onDataEvent(event)
    {
        super.onDataEvent(event);

        if (event.type == "add-component")
        {
           if (event.detail.component_type == "photo" && event.detail.creation != "dropped")
            {
                let components = [];
                let pageWidth = this.print.pageWidth;
                let currentArea = event.detail.area ? this.getAreaForPage(event.detail.area) : this.currentArea;
                let photosComponents = currentArea.data.photosComponents;
                let activePartWasEmpty = false;
                let activePart = event.detail.side || "";

                if (activePart == "")
                {
                    if (currentArea.activePart == "")
                    {
                        activePartWasEmpty = true;
                        activePart = currentArea.page.isFirstPage ? "right" : "left";
                    }
                    else
                        activePart = currentArea.activePart;
                }

                
                components = photosComponents.filter(function(a) {
                    let bounding = fx.graphics.getBoundingRect(a, a.rotation);
                    return (activePart == "left") ? (bounding.x < pageWidth) : (bounding.x >= pageWidth + currentArea.extraWidth);
                });

                currentArea.initLayoutData();

                // TODO : limiter à 4

                if (components.length > 10)
                    return;

                let exist = false;
                for (let i = 0; i < components.length; i++)
                {
                    if ( event.detail.content == components.getItemAt(i).content)
                    {
                        exist = true;
                        break;
                    }
                }

                if (exist)
                    return;

                components.sort( (a, b) => a.x - b.x );
                // first find if a photo component is empty, and use it
                // otherwise find layout with enougth pics
                for(let i = 0; i < components.length; i++)
                {
                    let component = components.getItemAt(i);
                    if (component.content == "")
                    {
                        component.content = event.detail.content;
                        return;
                    }
                }

                // before to fill page, check if active part was empty, and if too many pics on left side
                if (activePartWasEmpty)
                {
                    let leftComponents = photosComponents.filter(function(a) {
                        let bounding = fx.graphics.getBoundingRect(a, a.rotation);
                        return (bounding.x < pageWidth) && a.content != "";
                    });

                    let rightComponents = photosComponents.filter(function(a) {
                        let bounding = fx.graphics.getBoundingRect(a, a.rotation);
                        return (bounding.x >= pageWidth + currentArea.extraWidth) && a.content != "";
                    });
                    

                    if (activePart == "left" && leftComponents.length >= 4 && leftComponents.length > rightComponents.length)
                    {
                        activePart = "right";
                        components = rightComponents;
                    }
                    else
                    if (activePart == "right" && rightComponents.length >= 4 && rightComponents.length > leftComponents.length)
                    {
                        activePart = "left";
                        components = leftComponents;
                    }
                }


                let photos = [];
               
                for(let i = 0; i < components.length; i++)
                {
                    let component = components.getItemAt(i);
                    let photo = this.model.photos.find({id : component.content})
                    if (photo)
                        photos.push( photo )
                }

                let photo = this.model.photos.find({id : event.detail.content});
                if (photo)
                    photos.push( photo )

                let layouts = fx.service("LayoutsGenerator").getLayouts(photos);

                pageWidth = this.print.pageWidth;
                currentArea.data.addPhoto( photos, activePart, pageWidth, currentArea.pageHeight, currentArea.extraWidth, layouts[0], true );

                return;
            }


            if (event.detail.page)
            {
                this.currentArea = this.getAreaForPage(event.detail.page.id);
                delete event.detail.page;
            }

            // so ToolBar and Frame are removed
            this.currentElement = null;

            if (event.detail.area)
                this.currentArea = this.getAreaForPage(event.detail.area);
            
            this.currentArea.addComponent( event.detail );
        }
            
        if (event.type == "apply-layout")
        {
            if (event.data.area)
                this.currentArea = this.getAreaForPage(event.data.area);

            let layout = this.model.layouts.find({id : event.detail.content});

            if (this.currentArea)
                this.currentArea.applyLayout( layout/*, this.currentArea.activePart */);

            event.cancel(); // so layout is not applied somewhere else
        }
           
      
        if (event.type == "select-page")
        {
            this.currentArea = this.getAreaForPage(event.detail);
            this.scrollToCurrentArea(true);
        }

		if (event.type == "text-size-updated")
		{
			if (event.model instanceof models.CreationElementContent && event.model.isText) // let's check if text is not in lostBorder
			{
                
                let area = this.getAreaForPage(event.model.creation_element_id);
                if (area)
                {
                    let element = area.getChildFromData(event.model);
                    
                    let correction = this._mover.lockOnLostBorderCoordinates( event.model.x, event.model.y, event.model.rotation, event.model.width, event.model.height, area, element);
                    event.model.event("text-outside", {init : event.detail, corrected : correction.corrected});
                }
			}
		}

        if (event.type == "remove-creation")
            this._removePage(event.detail);
    }

    
    updateCurrentView(noanimate)
    {
        this.disableScrollUpdates();
        this.currentView.update(!noanimate);
        this.delay(this._selectAddedPage, this._newPage ? 0 : 250);
    }

    _selectAddedPage()
    {
        if (this._newPage)
        {
            this.currentView.select(this._newPage, true);
            this._newPage = null;
        }
    }

    onDataUpdated(action)
    {
        super.onDataUpdated(action);

        if (action.type == "addItemAt" && action.data instanceof models.CreationElement)
        {
            this._allChilds = null;
            
            this._newPage = new shared.stage.PrintArea(action.data,  this.model, this)
            this._newPage.visibleAtStart = false;
            this._newPage.effect = "fade";

            let position = this.getChilds().length - 1;
            this.addEditableArea( this._newPage, {width : this.print.pageWidth, height : this.print.pageHeight}, position);

            this.pages.push(this._newPage);

            position = this.getChilds().length - 1;
            
            if (this.model.zoom == 25)
                this._newPage.addClass("movable");
            
            if (action.history)
                this.delay(this.updateCurrentView, this._newPage ? 0 : 250);
        }

        if (action.type == "removeItem" && action.data instanceof models.CreationElement)
        {
            this._allChilds = null;

            let area = this.getAreaForPage(action.data.id);
            this.removeEditableArea(area);
            
            this.pages.remove(area);
            this.delay( this.updateCurrentView, action.history ? 50 : 0);
        }

        if (action.type == "moveItem" || action.type == "moveItemAt" && action.data instanceof models.CreationElement)
        {
            this._allChilds = null;
            this.delay( this.updateCurrentView, action.history ? 50 : 0);
        }


    }

    _updateCreationLabel()
    {
		if (!this._topInfoText) return;

        this._topInfoText.text = fx.text("$ photos, $€ / photo", this.print.numPrints, this.print.pricePerPrint); 
    }

    /*************************** Events  *************************/


    _onPhotoAdd()
    {
        this.model.event("selectphotos");
    }

    _removePage(page)
    {
        page.delete();
    }


    /*************************** Actions  *************************/

    addEditableArea(area, viewport, position)
    {
        area.autoDelete = false;
        area.options = this.options;

        position = (position !== undefined) ? position : undefined;

        this.addChild(area, viewport, "", position);

        this._editableAreas.push(area)

        this.on("select", this.onSelect, area);
    }

    removeEditableArea(area)
    {
        if (area)
        {
            this.removeChild(area, true);
            this._editableAreas.remove(area.id);
            this.off("select", this.onSelect, area);
        }
    }

    removeAllEditableAreas()
    {
        let area;
        while(area = this._editableAreas.pop())
        {
            this.off("select", this.onSelect, area);
            this.removeChild(area, true);
        }
    }

    getArea(id)
    {
        for (let i = 0; i < this._editableAreas.length; i++)
        {
            if (this._editableAreas[i].id == id)
                return this._editableAreas[i];
        }
    }

    getAreaForPage(id)
    {
        for (let i = 0; i < this._editableAreas.length; i++)
        {
            if (this._editableAreas[i].data && this._editableAreas[i].data.id == id)
                return this._editableAreas[i];
        }
    }

    enable()
    {    
        if (this.enabled)
            return;
                
        super.enable();

        this.on("scrollChanged", this.onScroll);                
    }

    
    disable()
    {
        if (!this.enabled)
            return;
                
        super.disable();

        this.off("scrollChanged", this.onScroll);
    }

    addCreation(photo)
    {
        let print = this.print.addElement(false, "right", true, true);
        print.photosComponents.getItemAt(0).content = photo.id;
    }
    
    buildBoard()
    {
        this.removeAllEditableAreas();

        if (!this.print || !this.print.prints) return;
        
        this._topInfoText = new fx.components.Text({className : "topInfoText"});
        this.addChild( this._topInfoText , {width : "auto", top : 10, left : "center"});

        this.pages = [];

        for (let i = 0; i < this.print.prints.length; i++)
        {
            let printPage = this.print.prints.getItemAt(i);

            let page = new shared.stage.PrintArea(printPage, this.model, this);
            page.effect = "fade";
            this.pages.push(page);
            this.addEditableArea( page, {width : this.print.pageWidth, height : this.print.pageHeight} );
        }

        // Card component for adding new photos when photo list is empty
        this._addPhotoCard = new fx.components.Card({
            data:this.data, 
            title: fx.text("Ajouter des photos"), 
            text: "( <span class='price'>" + ""+this.print.pricePerPrint+"€" + "</span> / "+fx.text("photo")+" ) <br/> "+
            fx.text("Veuillez ajouter au moins $ photos", this.print.minPages), 
            buttonLabel: fx.text("Ajouter des photos"),
            icon: fx.get("assets").cameraAdd, 
            onButtonClick: function(){
                this.data.event("selectphotos");
        }});
        this.addChild(this._addPhotoCard);
        this._addPhotoButton = new fx.components.Button({label : fx.text("Ajouter des photos"), className : "addPhotoButton"});
        this.addChild(this._addPhotoButton, {width : "270", height : "100"});
        this._addPhotoButton.css("display", "none");
        this._addPhotoButton.visibleAtStart=false;
        this._addPhotoCard.css("display", "block");

        this.on("click", this._onPhotoAdd, this._addPhotoButton);
        this._updateCreationLabel();

        this.currentView.update(false);

        this.currentArea = this._editableAreas.getItemAt(0);
    }

    _scrollToCurrentPage()
    {
        if (this.currentPage)
        {
            this.currentArea = this.getAreaForPage(this.currentPage.id);
            this.scrollToCurrentArea(true);

            this._currentPage = null;
        }
    }

    // when history back/forward and current page changes
    _currentPageUpdated()
    {
        this.currentPage = this.model.history.currentPage;
    }

    _editCurrentElement()
    {
        if (this.currentElement instanceof shared.stage.components.Text)
            this.currentElement.onEdit();
    }


});